import React from 'react';
import PropTypes from 'prop-types';
import { useBreakpoint } from '../customHooks/breakpoints';
import styled from 'styled-components';
import { BookButtons } from './BookButtons';
import { belowBreakpoint, breakpoints } from '../utils';
import { renderPricingBox } from '../../shared/components/PricingBox';

const Container = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  color: #666;
  min-width: 100%;
`;

const Description = styled.div`
  padding: 1rem 1rem 1rem;
  flex: 1;
  max-width: 75%;

  ${belowBreakpoint(breakpoints.md)} {
    padding: 1rem 0.5rem 0.5rem 0;
  }
`;

const Drawer = ({
  shouldShowNoAvailability,
  shouldNotShowDeepLinkButton,
  eventSeries,
  subEvent,
  provider,
  memberDeepLinks,
  price,
  description,
  checkoutBaseUrl,
  checkoutTheme,
  bookableProviders,
  uniqueId,
  setModal,
  admissionsPolicyUrl,
  showPrices,
}) => {
  const deviceWidth = useBreakpoint();

  if (deviceWidth === 'sm' || deviceWidth === 'md') {
    return (
      <Container>
        {!shouldShowNoAvailability && (
          <BookButtons
            subEvent={subEvent}
            eventSeries={eventSeries}
            checkoutBaseUrl={checkoutBaseUrl}
            bookableProviders={bookableProviders}
            memberDeepLinks={memberDeepLinks}
            uniqueId={uniqueId}
            provider={provider}
            checkoutTheme={checkoutTheme}
            setModal={setModal}
            admissionsPolicyUrl={admissionsPolicyUrl}
          />
        )}
        {description && <Description>{description}</Description>}
        {renderPricingBox(price, showPrices)}
      </Container>
    );
  }

  return (
    <Container>
      {description && <Description>{description}</Description>}
      {renderPricingBox(price, showPrices)}
    </Container>
  );
};

Drawer.propTypes = {
  shouldShowNoAvailability: PropTypes.bool,
  shouldNotShowDeepLinkButton: PropTypes.bool,
  subEvent: PropTypes.object,
  eventSeries: PropTypes.object,
  provider: PropTypes.string,
  memberDeepLinks: PropTypes.object,
  price: PropTypes.shape({
    opportunityPrice: PropTypes.string,
    offers: PropTypes.arrayOf(PropTypes.object),
  }),
  description: PropTypes.string,
  checkoutBaseUrl: PropTypes.string,
  checkoutTheme: PropTypes.string,
  bookableProviders: PropTypes.array,
  uniqueId: PropTypes.string,
  setModal: PropTypes.func,
  admissionsPolicyUrl: PropTypes.string,
  showPrices: PropTypes.bool,
};

export default Drawer;
